import { createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        headerContainer: {
            display: 'flex',
            alignItems: 'center',
            padding: '0px 16px',
            borderBottom: `1px solid ${theme.palette.grey['300']}`,
        },
        iconButton: {
            color: theme.palette.common.black,
            marginRight: '10px',
        },
    })
);
